import { IonIcon } from '@ionic/react'
import Box from '@mui/material/Box'
import { flashOutline } from 'ionicons/icons'
import React from 'react'

interface CarStateBarProps {
	darkModeEnabled: boolean
	batteryLevel: number
	chargeLimit: number
	isFullyCharged: boolean
}

const CarStateBar = ({
	isFullyCharged,
	chargeLimit,
	batteryLevel,
	darkModeEnabled,
}: CarStateBarProps) => {
	const minCharge = 20

	const green = darkModeEnabled ? '#b7dedc' : '#52ae32'

	return (
		<div className='bar rounded-full border bg-background-200-light dark:bg-surface-dark border-brand-primary-100-light dark:border-[#b7dedc]'>
			{batteryLevel >= minCharge ? (
				<Box
					sx={{
						width: `calc(${minCharge}% - 0.25rem)`,
						height: '80%',
						margin: '0 0.125rem 0 0.25rem',
						borderRadius: '16px 2px 2px 16px',
						backgroundColor: green,
					}}
				/>
			) : (
				<>
					<Box
						sx={{
							width: `${batteryLevel < 5 ? 'calc(5% - 0.25rem)' : `calc(${batteryLevel}% - 2px)`}`,
							height: '80%',
							margin: '0 0.125rem',
							borderRadius: '16px 2px 2px 16px',
							backgroundColor: green,
						}}
					/>
					{minCharge - batteryLevel > 0 ? (
						<Box
							sx={{
								width: `calc(${minCharge - batteryLevel}% - 4px)`,
								height: '80%',
								margin: `0 0.125rem`,
								borderRadius: '2px',
								backgroundColor: '#ffc13e',
							}}
						/>
					) : null}
				</>
			)}

			{batteryLevel - minCharge > 0 ? (
				<Box
					sx={{
						width: `calc(${batteryLevel - minCharge}% - 4px)`,
						height: '80%',
						margin: '0 0.125rem',
						borderRadius: '2px',
						backgroundColor: green,
					}}
				/>
			) : null}

			{!isFullyCharged ? (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',

						color: 'black',
						fontSize: '12px',

						width: `calc(${100 - (batteryLevel + (100 - chargeLimit))}% - 0.25rem)`,
						height: '80%',
						margin: '0 0 0 0.25rem',
						borderRadius: '2px 16px 16px 2px',
						backgroundColor: '#ffc13e;',
					}}
				>
					{chargeLimit - batteryLevel > 5 ? (
						<IonIcon className='text-text-dark' icon={flashOutline} />
					) : null}
					{chargeLimit - batteryLevel > 5 ? (
						<span className='text-text-dark'>{`${100 - (batteryLevel + (100 - chargeLimit))}%`}</span>
					) : null}
				</Box>
			) : null}

			<div className='reserve text-text-grey-200 dark:text-text-grey-100'>
				{Math.min(101 - chargeLimit, 100)}%
			</div>
		</div>
	)
}

export default CarStateBar
